var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"true","align-center":"true"}},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" A critical error has occurred. Please contact customer support. ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }